/** @jsxImportSource @emotion/react */
import { Link } from "atoms";
import { User } from "features/auth";

type UserSearchResultsParams = {
  results: User[];
};

const css = {
  form: {
    marginLeft: "auto",
    marginRight: "auto",
  },
  label: {
    margin: "1rem 0",
  },
  buttonWrapper: {
    display: "flex",
    flexDirection: "row" as const,
    alignItems: "baseline",
  },
  results: {
    marginTop: "1rem",
  },
  table: {
    th: {
      textAlign: "left" as const,
      paddingRight: "8px",
    },
  },
  hugs: {
    display: "flex",
    img: {
      maxWidth: "100px",
      margin: "4px",
    },
  },
  input: {
    borderColor: "black",
    maxWidth: "600px",
  },
  firstColumn: {
    textAlign: "left",
  } as const,
  searchResult: {
    marginTop: "40px",
    marginBottom: "60px",
  },
  linkCell: {
    paddingTop: "0.5rem",
    fontWeight: "normal",
    textAlign: "left",
  } as const,
};

const safeString = (s: string | undefined) => s || "None";
const safeStringArray = (s: string[] | undefined) =>
  (s && s.length > 0 ? s : ["None"]).join(", ");

function UserSearchResults({ results }: UserSearchResultsParams) {
  return (
    <div>
      {results.map((user) => (
        <div css={css.searchResult} key={user.id}>
          <table css={css.table}>
            <tbody>
              <tr>
                <th style={css.firstColumn}>User:</th>
                <td>
                  <Link to={`/admin/users/${user.id}`}>
                    {user.name || "No Name"}
                  </Link>
                </td>
              </tr>
              <tr>
                <th style={css.firstColumn}>Roles:</th>
                <td>{safeStringArray(user.utilities)}</td>
              </tr>
              <tr>
                <th style={css.firstColumn}>Discord:</th>
                <td>{safeString(user.discord)}</td>
              </tr>
              <tr>
                <th style={css.firstColumn}>Wallets:</th>
                <td>{safeStringArray(user.wallets)}</td>
              </tr>
              <tr>
                <td css={css.linkCell} colSpan={2}>
                  <Link to={`/admin/users/${user.id}`}>View User Profile</Link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
}

export { UserSearchResults };
